/* global _ TweenMax */
const React = require('react');
const Frame = require('../../views/Frame.jsx');
const Extras = require('../../../data/extras.json');

// const createSprite = require('../../../lib/createSprite');
const spritesHelper = require('../../../lib/spritesHelper');
// const Utils = require('../../../lib/utils');
const Audio = require('../../../lib/audio');

const BlobsAnimations = require('../../../animations/blobs');
const PaintersAnimations = require('../../../animations/painters');
const CommonAnimations = require('../../../animations/common');

const Painters = React.createClass({

    propTypes: {
        hideFirstCharacter: React.PropTypes.bool,

        index: React.PropTypes.number,
        intensity: React.PropTypes.number,
        play: React.PropTypes.bool,
        width: React.PropTypes.number,
        height: React.PropTypes.number,
        border: React.PropTypes.number,
        objs: React.PropTypes.object,
        container: React.PropTypes.object,
        movieclipKeys: React.PropTypes.array,
        paintersPaintableBlobsProbabilities: React.PropTypes.object,
        paintersCleanableBlobsProbabilities: React.PropTypes.object,

        titles: React.PropTypes.array,
        roles: React.PropTypes.array,
    },

    contextTypes: {
        minIntensity: React.PropTypes.number,
        maxIntensity: React.PropTypes.number,
        cleanTint: React.PropTypes.number,
        dirtyTints: React.PropTypes.array,
        language: React.PropTypes.string,
    },

    sprites: null,
    timeline: null,
    movieclipTimelines: null,
    audios: null,

    getDefaultProps: function()
    {
        return {
            hideFirstCharacter: false,
            texts: [
                // {
                //     title: 'Tim Goulet',
                //     subtitle: 'Ingénieur\nfinancier',
                //     opts: {
                //         align: 'right',
                //         x: 1010,
                //         y: 200
                //     }
                //
                // },
                {
                    title: 'Josh McTavish',
                    subtitle: 'Ingénieur\nfinancier',
                    opts: {
                        x: 80,
                        y: 500
                    }
                },
                {
                    title: 'Aloo Gosh',
                    subtitle: 'Ingénieur\nfinancier',
                    opts: {
                        align: 'right',
                        x: 1040,
                        y: 960
                    }
                }
            ],
            backgroundKey: 'paintersBg',
            className: 'painters',
            movieclipKeys: ['sprayGuy', 'laserGuy'],
            paintersPaintableBlobsProbabilities: {
                '1': 3/10,
                '2': 6/10,
                // '3': 10/10
            },
            paintersCleanableBlobsProbabilities: {
                '1': 9/10,
                '2': 7/10,
                // '3': 2/10
            },
            audioUrls: {
                treadmill: '/audio/28nov/titrisation-convoyeur-loop.mp3',
                // torch: new Audio('/audio/28nov/titrisation-torche-01.mp3'),
                spray1: '/audio/28nov/titrisation-spray-paint-01.mp3',
                spray2: '/audio/28nov/titrisation-spray-paint-02.mp3',
                laser: '/audio/28nov/titrisation-yeux-laser-03.mp3',
            },
            titles: ['josh', 'aloo'],
            roles: ['josh_title', 'aloo_title'],
        };
    },

    render: function()
    {
        this.texts = this.props.texts.map((text, idx) => {
            return _.merge(text,
                {
                    title: Extras[this.props.titles[idx]].text[this.context.language],
                    subtitle: Extras[this.props.roles[idx]].text[this.context.language],
                },
            );
        });

        return (
            <Frame
                {...this.props}
                onBuild={this.build}
                onPlay={this.play}
                onPause={this.pause}
                onDestroy={this.destroy}
                onIntensityChanged={this.updateIntensity}
                texts={this.texts}
            />
        );
    },

    build: function(container, timeline)
    {
        this.sprites = {
            container: container,
        };
        this.timeline = timeline;

        this.audios = {};
        _.forOwn(this.props.audioUrls, _.bind(function(value, key){
            if (key === 'treadmill') {
                this.audios[key] = new Audio(value, {
                    loop: true,
                    channel: 'frame'
                });
            } else {
                this.audios[key] = new Audio(value);
            }
        }, this));

        this.buildObjects();
        this.animateObjects();
    },

    play: function()
    {
        if (this.audios.treadmill) {
            this.audios.treadmill.play();
        }

        if (this.props.hideFirstCharacter === true) {
            this.hideTimeout = setTimeout(this.animateHideFirstCharacter, 4000);
        }
    },

    pause: function()
    {
        this.audios.treadmill.pause();
    },

    destroy: function()
    {
        Object.keys(this.audios).forEach((audioKey) => {
            this.audios[audioKey].destroy();
            this.audios[audioKey] = null;
        });

        if (this.sprites) {
            Object.keys(this.sprites).forEach(key => (
                TweenMax.killTweensOf(this.sprites[key])
            ));
        }
        this.sprites = null;

        this.sprites = null;
        this.timeline = null;
        this.audios = null;
        this.movieclipTimelines = null;
    },

    buildObjects: function()
    {
        var props = this.props;
        var objs = props.objs;
        var context = this.context;
        var sprites = this.sprites;
        var container = sprites.container;
        var scale = props.scale;

        // painters
        var blobPainters = spritesHelper.addBlobPainters(props.width, props.height, {
            movieclipKeys: props.movieclipKeys,
            sprites: sprites,
            objectsWithTextures: objs,
            minIntensity: context.minIntensity,
            maxIntensity: context.maxIntensity,
            cleanTint: context.cleanTint,
            dirtyTints: context.dirtyTints,
        });

        this.blobPainters = blobPainters;
        blobPainters.container.y;

        sprites.paintersBlobsGroups = blobPainters.group;
        container.addChild(blobPainters.container);
    },

    animateObjects: function()
    {
        var timeline = this.timeline;

        var props = this.props;
        var context = this.context;
        var sprites = this.sprites;
        var objects = props.objs;
        var width = props.width;

        var i, j, movieclipProp, movieclip, movieclipObject, effectKey, effectObject, effectCount;

        // blobs
        sprites.paintersBlobsGroups.map(function(painterBlobsGroup, painterIndex){
            painterBlobsGroup.map(function(blobGroup, blobGroupIndex){
                blobGroup.map(function(blob, blobIndex){
                    timeline.add(BlobsAnimations.getPaintBlobTimeline(blob, {
                        width: width + width * 0.15,
                        cleanTint: context.cleanTint,
                        dirtyTints: context.dirtyTints,
                        zoneStartRatio: painterIndex === 0 || painterIndex === 2 ? 0.1 : 0.4,
                        zoneEndRatio: painterIndex === 0 || painterIndex === 2 ? 0.6 : 0.8,
                        paintDuration: painterIndex < 2 ? 0.4 : 0.05,
                    }), blobGroupIndex * 0.5 + painterIndex * 0.3);
                });
            });
        });

        // painters
        this.movieclipTimelines = [];
        props.movieclipKeys.map(_.bind(function(movieclipKey, movieclipIndex){

            var intensityMovieclips = [];
            for (i = context.minIntensity; i <= context.maxIntensity; i++)
            {
                movieclipProp = movieclipKey+i;
                movieclip = sprites[movieclipProp];
                movieclipObject = objects[movieclipProp];
                movieclip.name = movieclipKey+i;
                intensityMovieclips.push(movieclip);
                if (i === 1)
                {
                    effectKey = _.get(movieclipObject, 'effectSpriteKey');
                    effectObject = _.get(objects, effectKey);
                    effectCount = _.get(effectObject, 'count', 1);

                    for (j = 0; j < effectCount; j++)
                    {
                        var effectSprite = _.get(sprites, effectKey+j, null);
                        this.movieclipTimelines.push(PaintersAnimations.getPainterEffectTimeline(effectSprite, effectKey));
                    }
                }
            }
            this.movieclipTimelines.push(timeline.add(CommonAnimations.getMovieclipTimeline(intensityMovieclips, {
                fps: 3.5,
                onFrameUpdate: this.onIntensityMovieclipFrameUpdate
            }), movieclipIndex * 0.1));
        }, this));

        if (this.props.onAnimationReady) {
            this.props.onAnimationReady(timeline);
        }
    },

    animateHideFirstCharacter() {
        const sprites = this.sprites;
        const objects = this.props.objs;

        if (sprites !== null) {
            const spritesToHide = [
                sprites.sprayGuy1,
                sprites.sprayGuy2,
                sprites.sprayGuy3,
                sprites.sprayGuyEffect0,
                sprites.sprayGuyblobs,
            ];

            TweenMax.to(spritesToHide, 1, {
                alpha: 0,
            });

            // Stop the timelines
            this.movieclipTimelines.forEach((movieclipTimeline, idx) => {
                if (idx === 3 || idx === 0) { // The spray guy ones
                    movieclipTimeline.stop();
                }
            });

            // Make sure beams are out
            const movieclipKey = 'sprayGuy';
            const i = 1;

            const movieclipProp = movieclipKey + i;
            const movieclip = sprites[movieclipProp];
            const movieclipObject = objects[movieclipProp];
            movieclip.visible = false;

            const effectKey = _.get(movieclipObject, 'effectSpriteKey');
            const effectObject = _.get(objects, effectKey);
            const effectCount = _.get(effectObject, 'count', 1);

            for (let j = 0; j < effectCount; j += 1) {
                const effectSprite = _.get(sprites, effectKey + j, null);
                TweenMax.to(effectSprite, 1, {
                    alpha: 0,
                });
            }
        }
    },

    updateIntensity: function(prevIntensity)
    {
        var props = this.props;
        var state = this.state;
        var context = this.context;
        var sprites = this.sprites;

        var intensity = props.intensity;
        var minIntensity = context.minIntensity;
        var maxIntensity = context.maxIntensity;

        prevIntensity = typeof prevIntensity !== 'undefined' ? prevIntensity : intensity;

        // movieclip timelines
        _.each(this.movieclipTimelines, function(movieclipTimeline) {
            movieclipTimeline.timeScale(1 + (intensity-2) * 0.15);
        });

        // painters
        props.movieclipKeys.map(function(movieclipKey)
        {
            for (var i = minIntensity; i <= maxIntensity; i++)
            {
                var movieclip = sprites[movieclipKey+i];
                movieclip.visible = i === intensity;
                // movieclip.timeScale(1 + (intensity-2) * 0.15);

                // PaintersAnimations.updateMovieclipFrameEffect(movieclip, {
                //     allObjects: props.objs,
                //     sprites: sprites
                // });
            }
        });

        // blobs
        var paintersPaintableBlobsProbability = props.paintersPaintableBlobsProbabilities[intensity];
        var paintersCleanableBlobsProbability = props.paintersCleanableBlobsProbabilities[intensity];

        sprites.paintersBlobsGroups.map(function(blobsGroups, painterIndex){
            blobsGroups.map(function(blobGroup, blobGroupIndex){
                blobGroup.map(function(blob, blobIndex){
                    blob.paintable = _.random(0, 1, true) < paintersPaintableBlobsProbability;
                    blob.cleanable = _.random(0, 1, true) < paintersCleanableBlobsProbability;
                });
            });
        });
    },

    onIntensityMovieclipFrameUpdate: function(movieclip)
    {
        var movieclipName = movieclip.name;
        var name = movieclipName.slice(0, -1);
        var intensity = movieclipName.slice(-1);
        var props = this.props;

        PaintersAnimations.updateMovieclipFrameEffect(movieclip, {
            allObjects: props.objs,
            sprites: this.sprites
        }, this.audios);
    }

});

module.exports = Painters;



// WEBPACK FOOTER //
// ./js/components/frames/_common/Painters.jsx